<template>
  <div class="preview">
    <div class="content">
      <div class="ql-editor" v-html="intro"></div>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: "preview",
  props: {
    data: ''
  },
  data() {
    return {
      intro: ''
    }
  },
  watch: {
    data: {
      handler(val) {
        this.intro = val;
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">

.preview {
  margin: 20px 40px 0;
  background-image: url(../../../images/phone.png);
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 100px 16px;
  box-sizing: border-box;
  width: 315px;
  height: 700px;
  background-color: #fff;

  .content {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
    word-break: break-all;
    white-space: nowrap;
    max-width: 100%;

    img {
      max-width: 100%;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// preview.vue?26ccfa93